import { render, staticRenderFns } from "./ProductStockStatus.vue?vue&type=template&id=816b4d7a&"
import script from "./ProductStockStatus.vue?vue&type=script&lang=js&"
export * from "./ProductStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports